import { Button } from '@/components';
import { env } from '@/config/env';
import { useAnalytics } from '@/lib/analytics';
import { cn } from '@/utils';

import GoogleIcon from '../../assets/google-icon';

const GoogleSignInButton = ({ className }: { className?: string }) => {
  const { trackEvent } = useAnalytics();

  const handleClick = () => {
    // Track Google sign-in button click
    trackEvent('clickedLoginButton', 1, { method: 'google' });

    // Set flag to detect successful login after redirect
    try {
      localStorage.setItem('google_login_attempt', Date.now().toString());
    } catch {
      // Fail silently - tracking is not critical
    }

    // Redirect to Google for authentication
    globalThis.location.replace(
      `${env.API_URL}/user/v1/google-login?return_url=${env.APP_URL}`
    );
  };

  return (
    <Button
      type="button"
      variant="outline"
      className={cn('w-full', className)}
      icon={<GoogleIcon />}
      iconPosition="start"
      onClick={handleClick}
    >
      Sign in with Google
    </Button>
  );
};

export default GoogleSignInButton;
